export enum EProfilePaintSide {
    noPaint = 1,
    paintTop = 2,
    paintBottom = 3,
    paintBothSides = 4,
}
